import { IController, IWindowService } from 'angular';
import * as _ from 'lodash';

import { SdcWizardStepperService } from './../../../../../shared/services/sdc/sdc-wizard-stepper.service';
import { ISdcStore } from './../../../../flux/sdc-store.interface';
import { IWizState } from './../../../../sdc-state/sdc-state.typings';

const sdcKey = 'grad-planning';

export class GradPlanningWizardStepperCtrl implements IController {
  static $inject: string[] = ['$scope', 'SDCStore', 'SdcWizardStepperService', '$window'];

  public initialWizardState: IWizState;
  public currentFilter: any;

  private setUi;

  constructor(
    private $scope,
    private SDCStore: ISdcStore,
    private SdcWizardStepperService: SdcWizardStepperService,
    private $window: IWindowService,
  ) {}

  $onInit(): void {
    this.setUi = () => {
      this.currentFilter = _.last(this.SDCStore.getFilter().cohort);
    };

    this.$scope.$listenTo(this.SDCStore, ['filter'], this.setUi);

    // Stepper must be initialized with active step, etc. after loaded
    this.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) {
        this.$window.setTimeout(() => this.SdcWizardStepperService.init(sdcKey));
      }
    });
  }

  prevStep = this.SdcWizardStepperService.back;
  nextStep = this.SdcWizardStepperService.next;
}
